import * as React from "react";

import type { DesignaliProps } from "../../types";

export const Ungroup = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <rect width="8" height="6" x="5" y="4" rx="1" />
        <rect width="8" height="6" x="11" y="14" rx="1" />
      </svg>
    );
  },
);

export default Ungroup;
